import React from 'react'
import { Link } from '@ally/metronome-ui'
import { Private } from '@ally/private'
import { AccountDetails, Beneficiary } from '../../../types'
import { AcctDetailsItem, Dd, Dt } from './StyledDlElements'

interface BeneficiariesDlProps {
  account: AccountDetails
  withAllyTM?: string
}
// istanbul ignore file // TO DO METRONOME UPGRADE REMOVE IGNORE AFTER WE FIX TESTS FAILING

export const BeneficiariesDl: React.FC<BeneficiariesDlProps> = ({
  account,
  withAllyTM,
}) => {
  return (
    <AcctDetailsItem>
      <Dt>
        <Link
          to="/beneficiaries/deposit"
          unsupportedContent={<>Beneficiaries:</>}
          withAllyTM={withAllyTM}
        />
      </Dt>
      <Dd>
        {account.beneficiaries?.map((bene: Beneficiary) => {
          if ('firstName' in bene) {
            return (
              <Private key={bene.beneficiaryId}>
                <div>
                  {bene.firstName}
                  {` `}
                  {bene.middleName}
                  {` `}
                  {bene.lastName}
                </div>
              </Private>
            )
          }
          return (
            <Private>
              <div key={bene.beneficiaryId}>{bene.beneficiaryName}</div>
            </Private>
          )
        })}
      </Dd>
    </AcctDetailsItem>
  )
}
